import React from "react";
import {
  StyledAppWrapperContent,
  StyledAuthWrapper,
  StyledAuthWrapperCarouselPanel,
  StyledAuthWrapperFormPanel,
  StyledAuthWrapperScrollbar,
} from "./AuthWrapper.styled";
import PropTypes from "prop-types";
import { AuthCarousel } from "_lib";

const AuthWrapper = (props) => {
  const { children } = props;
  return (
    <StyledAuthWrapperScrollbar>
      <StyledAuthWrapper>
        <StyledAppWrapperContent>
          <StyledAuthWrapperFormPanel>
            {children}
          </StyledAuthWrapperFormPanel>
          <StyledAuthWrapperCarouselPanel>
            <AuthCarousel />
          </StyledAuthWrapperCarouselPanel>
        </StyledAppWrapperContent>
      </StyledAuthWrapper>
    </StyledAuthWrapperScrollbar>
  );
};

AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AuthWrapper;
